import React, { useState } from 'react';
import axios from 'axios';
import './SearchBar.css'; // Ensure the path to your CSS file is correct

function SearchBar({ onSearch }) {
  const [input, setInput] = useState('');

  const handleSearch = async () => {
    if (input.trim()) {
      try {
        const response = await axios.post('https://genai-demo-6onvxnvwqa-ue.a.run.app/api/search/', { query: input });
        console.log('API Response:', response.data);  // Log the full response object

        // Assuming the actual result is under response.data.response
        onSearch(response.data.response);  // Adjusted to pass the actual survey response text
        setInput(''); // Clear the input after search
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
    }
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        className="search-input"
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyPress={e => e.key === 'Enter' && handleSearch()}
        placeholder="Ask Prompta AI..."
      />
      <button className="search-button" onClick={handleSearch}>Insights</button>
    </div>
  );
}

export default SearchBar;
